import { render, staticRenderFns } from "./ExecutorFees.vue?vue&type=template&id=051b1f1f&scoped=true"
import script from "./ExecutorFees.vue?vue&type=script&lang=js"
export * from "./ExecutorFees.vue?vue&type=script&lang=js"
import style0 from "./ExecutorFees.vue?vue&type=style&index=0&id=051b1f1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051b1f1f",
  null
  
)

export default component.exports